var map = {
	"./en/admin-en.json": 878,
	"./en/common-en.json": 879,
	"./en/food-monitor-en.json": 880,
	"./en/jisppay-en.json": 881,
	"./en/retailer-en.json": 882,
	"./en/retailer.common-en.json": 883,
	"./en/shopper-en.json": 884,
	"./no/admin-no.json": 885,
	"./no/common-no.json": 886,
	"./no/food-monitor-no.json": 887,
	"./no/jisppay-no.json": 888,
	"./no/retailer-no.json": 889,
	"./no/retailer.common-no.json": 890,
	"./no/shopper-no.json": 891
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;


//////////////////
// WEBPACK FOOTER
// ./lang ^\.\/.*\.json$
// module id = 486
// module chunks = 6